import React from 'react';
import Component from '@vfuk/core-state-notification';
const StateNotification = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default StateNotification;
